<mat-card appearance="outlined" class="pnf-container">
  <mat-card-title class="ps-4">Unauthorized</mat-card-title>
  <mat-card-content>
    <p>You are not authorized to access this page.</p>
  </mat-card-content>
  <mat-card-actions>
    <button color="primary" routerLink="/" mat-raised-button>HOME</button>
  </mat-card-actions>
</mat-card>
